module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/content-container/port-call/registration/forms/security/security-details/security-details.component.css
// module id = ./src/app/main-content/content-container/port-call/registration/forms/security/security-details/security-details.component.css
// module chunks = main